import { apiClient } from '../lib/api-client';
import type {
  CategoryDto,
  CreateCategoryRequest,
  UpdateCategoryRequest,
} from '../types/admin-api';

export const categoryService = {
  getAll: async () => {
    const response = await apiClient.get<CategoryDto[]>('/categories');
    return response.data;
  },

  getById: async (id: string) => {
    const response = await apiClient.get<CategoryDto>(`/categories/${id}`);
    return response.data;
  },

  create: async (data: CreateCategoryRequest) => {
    const response = await apiClient.post<CategoryDto>('/categories', data);
    return response.data;
  },

  update: async (id: string, data: UpdateCategoryRequest) => {
    const response = await apiClient.put<CategoryDto>(`/categories/${id}`, data);
    return response.data;
  },

  delete: async (id: string) => {
    const response = await apiClient.delete(`/categories/${id}`);
    return response.data;
  },
};
